import client from '../client';

const cmsApi = {
  /** Clinic-editable landing page copy. */
  getLanding: () => client.get('/cms/landing'),
};

export default cmsApi;
